import { ActionType } from 'typesafe-actions';

import * as actions from '../actions/ChangeKnoInPlanActions';
import { ChangeKnoInPlanActionsEnum } from '../enums/ChangeKnoInPlanActionsEnum';
import { IKnoOrganisationChild } from '../../APIPackage/CatalogsModule/interfaces/IKnoOrganisationChild';
import { IPlanKnoChangeHistoryItem } from '../components/IPlanKnoChangeHistoryItem';

export type ChangeKnoInPlanAction = ActionType<typeof actions>;

export interface IChangeKnoInPlanState {
  ervkKnoOrganisationSearchQuery: string | null;
  ervkKnoOrganisations: IKnoOrganisationChild[];
  historyChangesItems: IPlanKnoChangeHistoryItem[];
}

const initialState: IChangeKnoInPlanState = {
  ervkKnoOrganisationSearchQuery: null,
  ervkKnoOrganisations: [],
  historyChangesItems: [],
};

export function changeKnoInPlanReducer(state: IChangeKnoInPlanState = initialState, action: ChangeKnoInPlanAction) {
  switch (action.type) {
    case ChangeKnoInPlanActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET: {
      const { knoOrganisations } = action.payload;
      const newState: IChangeKnoInPlanState = {
        ...state,
        ervkKnoOrganisations: knoOrganisations,
      };

      return newState;
    }
    case ChangeKnoInPlanActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET_SEARCH_QUERY: {
      const { searchQuery } = action.payload;
      const newState: IChangeKnoInPlanState = {
        ...state,
        ervkKnoOrganisationSearchQuery: searchQuery,
      };

      return newState;
    }

    case ChangeKnoInPlanActionsEnum.CHANGE_KNO_PLAN_HISTORY_CHANGES_SET: {
      const { historyItems } = action.payload;
      const newState: IChangeKnoInPlanState = {
        ...state,
        historyChangesItems: historyItems,
      };

      return newState;
    }
    default:
      return state;
  }
}
